import { connect, ConnectedProps } from 'react-redux';
import { createSelector } from 'reselect';
import { StateType } from '../../../state/state.types';

const foldersSelector = (state: StateType) => state.folders.folders;
const latestUpdatedFoldersSelector = (state: StateType) =>
  state.latestUpdated.folders;

const latestUpdatedFolders = createSelector(
  foldersSelector,
  latestUpdatedFoldersSelector,
  (folders, latest) =>
    latest.slice(0, 5).map((folderKey) => folders[folderKey]),
);

const mapState = (state: StateType) => ({
  folders: latestUpdatedFolders(state),
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
